module.exports = __webpack_public_path__ + "e7a8c8c332d2c153b540a9258b41ced2.svg";